export default __webpack_public_path__ + "static/media/8888ab51cc8d9750d2aa5a980a9ba39e1600888681164.1fbefda2.webp";